<template>
    <transition name="el-zoom-in-top">
        <div class="content-wrapper">
            <!-- Main content -->
            <section class="content">
              <br>
              <br>
              <br>
              <br><br>
              <br>
              <h1>Stay Tuned!</h1>
<h2>We will be filling this up with content in the future!</h2>
            </section>
            <!-- /.content -->
        </div>
    </transition>
</template>
<script>
  export default {
    name: 'updatePlaceholder'
  }
</script>



// WEBPACK FOOTER //
// UpdatePlaceholderPage.vue?7647ebeb